import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withIcon } from '../Icon';
export var Star75SVG = function Star75SVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28.28 11.46L21 10.12l-3.52-6.9C17.09 2.41 16.55 2 16 2s-1.09.41-1.51 1.22L11 10.12l-7.28 1.34c-1.8.34-2.26 1.71-1 3.06l5.16 5.6-1 7.78c-.17 1.32.39 2.1 1.34 2.1a2.68 2.68 0 001.19-.33L16 26.3l6.65 3.37a2.68 2.68 0 001.19.33c.95 0 1.51-.78 1.34-2.1l-1-7.78 5.16-5.6c1.2-1.35.74-2.72-1.06-3.06zm-6.26 8l-2.33-7.56 7.93 1.48z"
  }));
};
Star75SVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
Star75SVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Three Quarters Filled Star")
};
export default withIcon(Star75SVG);